import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWarehouse } from '@fortawesome/free-solid-svg-icons';

/**
 * Sticky overview of how much of each article the whole delivery consumes vs.
 * what is available in stock. Replaces the old wide matrix header: instead of
 * reading stock totals across 13 columns, all stock feedback lives here.
 *
 * `stockDetails` entries:
 *   { stockId, stockArticleName, stockAvailable, stockOnThisDelivery, overbooked }
 */
const StockSummaryPanel = ({
  stockDetails = [],
  overbooked,
  isLoading,
  onSubmit,
  comment = '',
  onCommentChange,
  noteComment = '',
  onNoteCommentChange,
}) => {
  const allocated = stockDetails.filter((d) => d.stockOnThisDelivery > 0);
  const totalUnits = allocated.reduce(
    (sum, d) => sum + d.stockOnThisDelivery,
    0
  );

  return (
    <div className='card position-sticky' style={{ top: '1rem' }}>
      <div className='card-header fw-bold'>Bestandsübersicht</div>
      <div className='card-body'>
        {allocated.length === 0 ? (
          <p className='text-muted mb-0'>
            Noch keine Mengen erfasst. Bestand pro Artikel erscheint hier.
          </p>
        ) : (
          <table className='table table-sm align-middle mb-0'>
            <thead>
              <tr className='text-muted small'>
                <th>Artikel</th>
                <th className='text-end'>
                  Lieferung /{' '}
                  <FontAwesomeIcon
                    icon={faWarehouse}
                    title='verfügbarer Bestand'
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              {allocated.map((detail) => (
                <tr key={detail.stockId}>
                  <td>{detail.stockArticleName}</td>
                  <td
                    className={`text-end text-nowrap ${
                      detail.overbooked ? 'text-danger fw-bold' : ''
                    }`}
                  >
                    {detail.stockOnThisDelivery} / {detail.stockAvailable}
                    {detail.overbooked && (
                      <span className='badge bg-danger ms-2'>
                        zu wenig Bestand
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      <div className='card-footer'>
        <div className='mb-2 text-start'>
          <label htmlFor='deliveryComment' className='form-label small mb-1'>
            Kommentar/Hinweis{' '}
            <span className='text-muted'>(optional, nur im System sichtbar)</span>
          </label>
          <textarea
            id='deliveryComment'
            className='form-control'
            rows={2}
            maxLength={255}
            value={comment}
            onChange={(e) => onCommentChange(e.target.value)}
            placeholder='z. B. Hinweis für die Auslieferung'
          />
        </div>
        <div className='mb-2 text-start'>
          <label htmlFor='deliveryNoteComment' className='form-label small mb-1'>
            Lieferschein-Hinweis{' '}
            <span className='text-muted'>
              (wird auf den Lieferschein/PDF gedruckt)
            </span>
          </label>
          <textarea
            id='deliveryNoteComment'
            className='form-control'
            rows={2}
            maxLength={255}
            value={noteComment}
            onChange={(e) => onNoteCommentChange(e.target.value)}
            placeholder='z. B. Hinweis, der auf dem Lieferschein erscheint'
          />
        </div>
        <div className='text-muted small mb-2'>
          Σ {allocated.length} Positionen · {totalUnits} Einheiten
        </div>
        <button
          className='btn btn-success w-100'
          onClick={onSubmit}
          disabled={overbooked || isLoading}
        >
          Lieferung anlegen
        </button>
        {overbooked && (
          <div className='text-danger small mt-2'>
            Mindestens ein Artikel überschreitet den verfügbaren Bestand.
          </div>
        )}
      </div>
    </div>
  );
};

export default StockSummaryPanel;
